import React, { useState, useContext, lazy, Suspense, ReactChild, ReactFragment, ReactPortal } from 'react';
import Loader from '../Loading'
import Affiliation from '../Affiliation';
import AmentiesIndex from '../AmenitiesAndServices/Table/index'
import GuestRooms from '../GuestRooms';

import ImagesIndex from '../Images'
import OtherDistributionSystemPage from '../OtherDistributionSystem'
import ReferencePoint from '../ReferencePoint/Table/index'
import Policies from '../Categories/Policies';
import RatePlans from '../Categories/RatePlans';
import EnvironmentalImpact from '../EnvironmentalImpact';
//import Recreation from '../Recreation/index'
import Recreation from '../Recreation/Table/index'
// import Attraction from '../Attraction/index';
import Attraction from '../Attraction';
import MeetingFacilities from '../Categories/MeetingFacilities';
import GDSinformation from '../GDSinformation/index'
import OtherPayments from '../OtherPayments';
import { rightContentWidthContext, UPDATE_RIGHT_CONTENT_WIDTH } from '../../layouts/RightContentWidthContext';
import ReservationInformation from '../Categories/ReservationInformation';
import NearbyHotels from '../Categories/NearbyHotels';
import ContactPerson from './../Categories/ContactPerson';
import BasicInformation from '../Categories/BasicInformation';
import DiningOptions from '../Categories/DiningOptions'

const Communications = lazy(() => import('../../components/Categories/Communications') )
const Ownership = lazy(() => import('../../components/Categories/Ownership') )
const Promotions = lazy(() => import('../../components/Categories/Promotions/index'))
const CustomValues = lazy(() => import('../../components/Categories/CustomValues'))

declare global {
    interface Window {
        rightContentWidth: string
    }
}
const CSIComponents = (props: any) => {

    const rightContent: any = useContext(rightContentWidthContext);

    const Loading: () =>  boolean | ReactChild | ReactFragment | ReactPortal | null = () => {
        return (
          <Loader type="medium" />
        )
      }

    const categorieRenderPage = () => {
        switch (props.categorie) {
            case 1: 
                return  <BasicInformation isEditable={props.isEditable} cancelEditable={props.cancelEditable} />
            case 2:
                return <GuestRooms isEditable={props.isEditable} cancelEditable={props.cancelEditable} />
            case 3:
                return <Affiliation isEditable={props.isEditable} cancelEditable={props.cancelEditable} />
            case 4:
                return <AmentiesIndex isEditable={props.isEditable} cancelEditable={props.cancelEditable} />
            case 11:
                return <ImagesIndex />
            case 23:
                return <OtherDistributionSystemPage />
            case 5:
                return <Attraction isEditable={props.isEditable} cancelEditable={props.cancelEditable} />
            case 6:
                return <EnvironmentalImpact isEditable={props.isEditable} cancelEditable={props.cancelEditable} />
            case 9:
                return <MeetingFacilities />
            case 10: 
                return (
                    <Suspense fallback={Loading()}>
                        <NearbyHotels isEditable={props.isEditable} cancelEditable={props.cancelEditable}/>
                    </Suspense>
                )
            case 13:
                return <RatePlans isEditable={props.isEditable} cancelEditable={props.cancelEditable} />
            case 15:
                return <ReferencePoint isEditable={props.isEditable} cancelEditable={props.cancelEditable} />
            case 25:
                return <OtherPayments isEditable={props.isEditable} cancelEditable={props.cancelEditable} />
            case 8:
                return <Policies isEditable={props.isEditable} cancelEditable={props.cancelEditable} />
            case 14:
                return <Recreation isEditable={props.isEditable} cancelEditable={props.cancelEditable} />
            case 7:
                return <GDSinformation isEditable={props.isEditable} cancelEditable={props.cancelEditable} />
            case 18: 
                return (
                    <Suspense fallback={Loading()}>
                        <Communications isEditable={props.isEditable} cancelEditable={props.cancelEditable} />
                    </Suspense>
                )
            case 19: 
                return (
                    <Suspense fallback={Loading()}>
                        <ReservationInformation isEditable={props.isEditable} cancelEditable={props.cancelEditable}/>
                    </Suspense>
                )
            case 26: 
                return (
                    <Suspense fallback={Loading()}>
                        <Ownership />
                    </Suspense>
                )
            case 12: 
                return (
                    <Suspense fallback={Loading()}>
                        <Promotions isEditable={props.isEditable} cancelEditable={props.cancelEditable}/>
                    </Suspense>
                )
            case 21: 
                return (
                    <Suspense fallback={Loading()}>
                        <ContactPerson />
                    </Suspense>
            )
            case 22: 
                return (
                    <Suspense fallback={Loading()}>
                        <DiningOptions />
                    </Suspense>
                )
            case 27: 
                return (
                    <Suspense fallback={Loading()}>
                        <CustomValues />
                    </Suspense>
                )
            default:
                return <div>404</div>
        }
    }

    let dom = document.getElementsByClassName('categorieMenu')[0] as HTMLElement;
    const [domWidth, setDomWidth] = useState(dom.offsetWidth + 'px')
    
    const iframeDom = document.querySelector('#csi-iframe') as any;
    // const debounceUpdateWidth= debounce(()=> rightContent?.dispatch({
    //     type: UPDATE_RIGHT_CONTENT_WIDTH,
    //     width: dom.offsetWidth + 50 + 'px'
    // }), 200,{
    //     leading:true
    // });
    iframeDom.contentWindow.window.document.body.onresize = function () {
        setDomWidth(dom.offsetWidth + 'px');
        window.rightContentWidth = dom.offsetWidth + 50 + 'px';
        rightContent?.dispatch({
            type: UPDATE_RIGHT_CONTENT_WIDTH,
            width: dom.offsetWidth + 50 + 'px'
        });
    }
    return (
        <div style={{ position: 'relative', width: `calc( 100% - ${domWidth})` }}>{categorieRenderPage()}</div>
    );
}


export default CSIComponents;
